import { createContext } from 'react'

import XyoWorldAuthenticatedEntity from './XyoWorldAuthenticatedEntity'
import XyoWorldAuthentication from './XyoWorldAuthentication'

interface Authentication {
  auth?: XyoWorldAuthentication | null
  authEntity?: XyoWorldAuthenticatedEntity | null
  signIn?: () => Promise<void>
  signOut?: () => void
}

export const AuthenticationContext = createContext<Authentication>({})
